module.exports = __webpack_public_path__ + "img/message.5fe566df.svg";